var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 6.297V6C19.25 3.582 17.918 2.25 15.5 2.25H5.5C3.983 2.25 2.75 3.483 2.75 5V18C2.75 20.418 4.082 21.75 6.5 21.75H18.5C20.918 21.75 22.25 20.418 22.25 18V10C22.25 7.845 21.192 6.553 19.25 6.297ZM20.75 15.75H17C16.035 15.75 15.25 14.965 15.25 14C15.25 13.035 16.035 12.25 17 12.25H20.75V15.75ZM5.5 3.75H15.5C17.077 3.75 17.75 4.423 17.75 6V6.25H5.5C4.811 6.25 4.25 5.689 4.25 5C4.25 4.311 4.811 3.75 5.5 3.75ZM18.5 20.25H6.5C4.923 20.25 4.25 19.577 4.25 18V7.44897C4.625 7.64097 5.05 7.75 5.5 7.75H18.5C20.077 7.75 20.75 8.423 20.75 10V10.75H17C15.208 10.75 13.75 12.208 13.75 14C13.75 15.792 15.208 17.25 17 17.25H20.75V18C20.75 19.577 20.077 20.25 18.5 20.25ZM17.51 13H17.52C18.073 13 18.52 13.448 18.52 14C18.52 14.552 18.073 15 17.52 15C16.968 15 16.515 14.552 16.515 14C16.515 13.448 16.958 13 17.51 13Z",
    fill: "#B1B5C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.c36bec605fab0e32044a68e5b14f1984.svg";
export { ForwardRef as ReactComponent };